import * as React from "react";
import { Button } from "antd";
import { OnroadText } from "../forms/ProductType";

interface IProps {
	coreTestResultId?: number;
	dataLocked: boolean;
	customFieldNotValidated: boolean;
	licensedProductContainsCore: boolean;
	getCoreTest: () => void;
	startCore: () => void;
	canEditCore: boolean;
	productType?: ProductType;
	selectedPurposeId?: any;
}

export const OnRoadButton: React.FC<IProps> = (props) => {
	let button: React.ReactFragment;

	if (props.coreTestResultId) {
		button = (
			<Button
				className="ml-auto btn-primary"
				onClick={props.getCoreTest}
				disabled={
					props.dataLocked ||
					!props.customFieldNotValidated ||
					!props.canEditCore ||
					!props.selectedPurposeId
				}
			>
				Edit {OnroadText(props.productType)}
			</Button>
		);
	} else {
		button = (
			<Button
				className="ml-auto btn-primary"
				onClick={props.startCore}
				disabled={
					!props.customFieldNotValidated ||
					!props.canEditCore ||
					!props.selectedPurposeId
				}
			>
				Start {OnroadText(props.productType)}
			</Button>
		);
	}

	if (!props.licensedProductContainsCore) {
		button = <React.Fragment />;
	}

	return <React.Fragment>{button}</React.Fragment>;
};
